import { render, staticRenderFns } from "./CustomFeaturePoints.vue?vue&type=template&id=2865b176&scoped=true&"
import script from "./CustomFeaturePoints.vue?vue&type=script&lang=js&"
export * from "./CustomFeaturePoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865b176",
  null
  
)

component.options.__file = "CustomFeaturePoints.vue"
export default component.exports